export class ImportedProductsFileMetrics {
    productItemsCount: number;
    productsCount: number;
    familiesCount: number;
}